var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StatCard',_vm._b({},'StatCard',_vm.$props,false),[_c('template',{slot:"badge"},[_vm._t("badge")],2),_vm._v(" "),_c('template',{slot:"default"},[_vm._t("default"),_vm._v(" "),_c('FlexSpacer'),_vm._v(" "),_c('span',{staticClass:"rank",class:{ 'rank--text': !_vm.isEmoji }},[_vm._v("\n      "+_vm._s(_vm.rankFormatted)+"\n    ")])],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }